<template>
  <section class="panel">
    <div class="toolbar">
      <el-input v-model="query.keyword" placeholder="昵称/手机号" clearable style="width:200px" />
      <el-select v-model="query.memberLevel" placeholder="会员等级" clearable style="width:150px">
        <el-option v-for="item in memberRules" :key="item.levelCode" :label="item.levelName" :value="item.levelCode" />
      </el-select>
      <el-button class="btn-search" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="avatarUrl" label="头像" width="80">
        <template slot-scope="{ row }">
          <el-avatar v-if="row.avatarUrl" :src="absolute(row.avatarUrl)" :size="36" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="age" label="年龄" width="90" />
      <el-table-column label="性别" width="90">
        <template slot-scope="{ row }">{{ genderLabel(row.gender) }}</template>
      </el-table-column>
      <el-table-column prop="memberLevel" label="会员等级" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="memberTagType(row.memberLevel)" size="small">{{ memberLabel(row.memberLevel) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="位置" min-width="260">
        <template slot-scope="{ row }">
          <div>{{ row.locationAddress || '未授权/未解析' }}</div>
          <div class="muted" v-if="row.latitude || row.longitude">{{ row.latitude }}, {{ row.longitude }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="{ row }">
          <el-button size="mini" class="btn-view" @click="openRecords(row)">查看扫码记录</el-button>
          <el-button size="mini" type="primary" plain @click="openVerifiedProducts(row)">查看已验证产品</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="page.page"
      :page-size="page.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; search() }"
      @current-change="p => { query.page = p; load() }"
    />

    <el-dialog :title="recordTitle" :visible.sync="recordsDialog" width="760px">
      <el-table :data="recordPage.records" border size="small">
        <el-table-column prop="scanTime" label="扫码时间" width="170" />
        <el-table-column prop="code" label="防伪码" min-width="160" />
        <el-table-column prop="productName" label="产品名称" />
        <el-table-column prop="batchNo" label="批次号" width="130" />
        <el-table-column label="结果" width="130">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="scanResultTagType(row.result)">
              {{ scanResultText(row.result) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next"
        :current-page="recordQuery.page"
        :page-size="recordQuery.size"
        :total="recordPage.total"
        @current-change="p => { recordQuery.page = p; loadRecords() }"
      />
    </el-dialog>

    <el-dialog :title="verifiedTitle" :visible.sync="verifiedDialog" width="880px">
      <div class="toolbar">
        <el-input
          v-model="verifiedQuery.productName"
          placeholder="产品名称"
          clearable
          style="width:220px"
          @keyup.enter.native="searchVerifiedProducts"
          @clear="searchVerifiedProducts"
        />
        <el-button class="btn-search" icon="el-icon-search" @click="searchVerifiedProducts">查询</el-button>
      </div>
      <el-table :data="verifiedPage.records" border size="small">
        <el-table-column label="产品" min-width="220">
          <template slot-scope="{ row }">
            <div class="product-cell">
              <el-avatar v-if="row.mainImageUrl" shape="square" :src="absolute(row.mainImageUrl)" :size="42" />
              <div>
                <div>{{ row.productName || '-' }}</div>
                <div class="muted">{{ productSpecText(row) }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="防伪码" min-width="160" />
        <el-table-column prop="batchNo" label="批次号" width="140" />
        <el-table-column prop="scanTime" label="验证时间" width="170" />
        <el-table-column label="状态" width="110">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success">{{ scanResultText(row.result) }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next"
        :current-page="verifiedQuery.page"
        :page-size="verifiedQuery.size"
        :page-sizes="[10, 20, 50]"
        :total="verifiedPage.total"
        @size-change="size => { verifiedQuery.size = size; searchVerifiedProducts() }"
        @current-change="p => { verifiedQuery.page = p; loadVerifiedProducts() }"
      />
    </el-dialog>
  </section>
</template>

<script>
import http, { absoluteUrl } from '../api'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const scanResultTextMap = {
  SUCCESS_FIRST: '首次核验通过',
  REPEAT: '重复扫码',
  NOT_FOUND: '防伪码不存在',
  REVOKED: '防伪码已失效',
  PARAM_ERROR: '参数异常',
  PRODUCT_NOT_FOUND: '产品不存在'
}

export default {
  data() {
    return {
      query: { page: 1, size: 10 },
      page: { ...blankPage },
      memberRules: [],
      recordsDialog: false,
      verifiedDialog: false,
      activeUser: null,
      recordQuery: { page: 1, size: 10 },
      recordPage: { ...blankPage },
      verifiedQuery: { page: 1, size: 10, productName: '' },
      verifiedPage: { ...blankPage }
    }
  },
  computed: {
    recordTitle() {
      return this.activeUser ? `${this.activeUser.nickname || '用户'}的扫码记录` : '扫码记录'
    },
    verifiedTitle() {
      return this.activeUser ? `${this.activeUser.nickname || '用户'}的已验证产品` : '已验证产品'
    }
  },
  mounted() {
    this.loadMemberRules()
    this.load()
  },
  methods: {
    absolute: absoluteUrl,
    memberLabel(level) {
      const rule = this.memberRules.find(item => item.levelCode === level)
      return rule ? rule.levelName : (level || '普通会员')
    },
    memberTagType(level) {
      if (level === 'BLACKLIST') return 'danger'
      if (level === 'VIP') return 'success'
      return ''
    },
    genderLabel(gender) {
      const map = { MALE: '男', FEMALE: '女' }
      return map[gender] || '-'
    },
    async loadMemberRules() {
      this.memberRules = await http.get('/admin/member-level-rules/enabled')
    },
    async load() {
      this.page = await http.get('/admin/users', { params: this.query })
    },
    search() {
      this.query.page = 1
      this.load()
    },
    async openRecords(row) {
      this.activeUser = row
      this.recordQuery = { page: 1, size: 10 }
      await this.loadRecords()
      this.recordsDialog = true
    },
    async loadRecords() {
      this.recordPage = await http.get(`/admin/users/${this.activeUser.id}/scan-records`, { params: this.recordQuery })
    },
    async openVerifiedProducts(row) {
      this.activeUser = row
      this.verifiedQuery = { page: 1, size: 10, productName: '' }
      await this.loadVerifiedProducts()
      this.verifiedDialog = true
    },
    async loadVerifiedProducts() {
      this.verifiedPage = await http.get(`/admin/users/${this.activeUser.id}/verified-products`, { params: this.verifiedQuery })
    },
    searchVerifiedProducts() {
      this.verifiedQuery.page = 1
      this.loadVerifiedProducts()
    },
    productSpecText(row) {
      return [row.seriesCategoryName || row.series, row.modelCategoryName || row.model, row.performanceCategoryName]
        .filter(Boolean)
        .join(' / ') || '暂无规格信息'
    },
    scanResultText(result) {
      return scanResultTextMap[result] || result || '-'
    },
    scanResultTagType(result) {
      if (result === 'SUCCESS_FIRST') return 'success'
      if (result === 'REPEAT') return 'warning'
      return 'danger'
    }
  }
}
</script>

<style scoped>
.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
}
</style>
